/* FABLAIR virtual try-on. Photos stay in memory until explicit consent + start.
 * Only the same-origin Shopify app proxy can authorize, reserve or debit quota.
 * No automatic POST retries: request UUID survives ambiguous network outcomes. */
(() => {
  'use strict';
  if (customElements.get('fablair-try-on')) return;
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const DEFINITE_REJECTIONS = new Set(['LOGIN_REQUIRED', 'INVALID_ORIGIN', 'INVALID_CSRF', 'INVALID_JSON', 'INVALID_CONTENT_TYPE', 'PAYLOAD_TOO_LARGE', 'INVALID_IMAGE', 'IMAGE_TOO_LARGE', 'IMAGE_DIMENSIONS', 'INVALID_PRODUCT', 'INVALID_VARIANT', 'PRODUCT_DISABLED', 'NO_PRODUCT_IMAGE', 'CONSENT_REQUIRED', 'INVALID_REQUEST_ID', 'FEATURE_DISABLED', 'RATE_LIMITED', 'CUSTOMER_LIMIT', 'STORE_LIMIT', 'ACTIVE_JOB']);
  const STATES = new Set(['submitting', 'queued', 'processing', 'completed', 'failed', 'uncertain']);
  const MAX_FILE = 12 * 1024 * 1024;
  const MAX_UPLOAD = 6 * 1024 * 1024;
  const MAX_OUTPUT = 12 * 1024 * 1024;
  const PILOT_ID = 'max-quality-20261001-v1';
  const shell = `
    <div class="fto__header"><span class="fto__brand">FABLAIR</span><button type="button" class="fto__close" data-fto-close aria-label="Sanal denemeyi kapat">×</button></div>
    <div class="fto__body">
      <p class="fto__eyebrow">SANA AİT BİR GÖRÜNÜM</p><h2 class="fto__title">Üzerinde hayal et.</h2>
      <p class="fto__intro">Beğendiğin parçayı kendi fotoğrafında gör. Seç, dene, kendine yakıştır.</p>
      <div class="fto__quota" hidden><strong><span class="fto__dots" aria-hidden="true"><i></i><i></i></span><span data-fto-quota></span></strong><small data-fto-reset></small></div>
      <div data-fto-panel="checking" class="fto__center"><span class="fto__spinner" aria-hidden="true"></span><p>Deneme hakların kontrol ediliyor…</p></div>
      <div data-fto-panel="gate" class="fto__center" hidden><div class="fto__symbol" aria-hidden="true">✧</div><h3 data-fto-gate-title></h3><p data-fto-gate-text></p><a class="fto__button" data-fto-login hidden>Giriş yap</a><button type="button" class="fto__button fto__button--light" data-fto-reload hidden>Yeniden kontrol et</button></div>
      <div data-fto-panel="upload" hidden>
        <div class="fto__product"><img data-fto-product-image alt="Denenecek ürün"><div><span class="fto__product-label">SEÇTİĞİN PARÇA</span><p class="fto__product-name" data-fto-product-title></p><p class="fto__product-variant" data-fto-product-variant></p></div></div>
        <div class="fto__grid"><div>
          <div class="fto__picker" data-fto-picker><svg width="42" height="48" viewBox="0 0 42 48" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><circle cx="21" cy="9" r="6"/><path d="M11 43V28l-4 8-4-2 7-15 7-2h8l7 2 7 15-4 2-4-8v15M21 28v16"/></svg><p class="fto__picker-title">Fotoğrafınla başla</p><p class="fto__picker-hint">Önden çekilmiş, net bir fotoğraf seç.<br>JPG, PNG veya WebP · En fazla 12 MB</p><button type="button" class="fto__button fto__button--light" data-fto-pick>Fotoğraf seç</button></div>
          <input class="fto__file" type="file" accept="image/jpeg,image/png,image/webp" aria-label="Deneme için fotoğraf seç" data-fto-file>
          <div class="fto__person-wrap" data-fto-person-wrap hidden><img class="fto__person" data-fto-person alt="Seçtiğin fotoğraf"><button type="button" class="fto__remove" data-fto-remove>Fotoğrafı kaldır</button></div>
        </div><div><h3 class="fto__subheading">Daha iyi bir sonuç için</h3><ul class="fto__tips"><li>Tek kişinin bulunduğu bir fotoğraf kullan.</li><li>Vücudun ve denenecek bölge net görünsün.</li><li>Önden dur; ellerin kıyafeti kapatmasın.</li><li>Bol kıyafetler sonucu etkileyebilir.</li></ul>
          <label class="fto__consent"><input type="checkbox" data-fto-consent><span>Fotoğrafımın sanal deneme oluşturmak için FASHN hizmetine iletilmesini kabul ediyorum.</span></label>
          <details class="fto__privacy"><summary>Fotoğrafım nasıl kullanılır?</summary><p>Yalnızca kendine ait veya kullanma iznin olan bir fotoğraf yükle. Denemeyi başlattığında fotoğrafın sonucu oluşturmak için FASHN ile paylaşılır. Veri işleme koşulları için <a data-fto-privacy target="_blank" rel="noopener">Gizlilik Politikamızı</a> inceleyebilirsin.</p></details>
          <button type="button" class="fto__button fto__button--full" data-fto-start disabled>Denemeyi başlat</button><p class="fto__note">Sonuç hazır olduğunda 1 deneme hakkın kullanılır.<br>Bu görsel, beden veya kalıp uyumu garantisi vermez.</p>
        </div></div>
      </div>
      <div data-fto-panel="progress" class="fto__center" hidden><div class="fto__progress-frame"><img data-fto-progress-image alt="" hidden><span class="fto__progress-symbol" data-fto-progress-symbol aria-hidden="true">✧</span></div><h3>Görünümün hazırlanıyor</h3><p data-fto-progress-text>Denemenin sonucu bekleniyor. Bu pencereyi kapatsan da işlem devam eder.</p></div>
      <div data-fto-panel="uncertain" class="fto__center" hidden><div class="fto__symbol" aria-hidden="true">⌁</div><h3>Denemeni kontrol edelim</h3><p data-fto-uncertain-text>İşlemin durumu henüz doğrulanamadı. Yeni deneme başlatmadan mevcut sonucu kontrol et.</p><button type="button" class="fto__button" data-fto-resume>Mevcut sonucu kontrol et</button><p class="fto__note" data-fto-job-number></p></div>
      <div data-fto-panel="failed" class="fto__center" hidden><div class="fto__symbol" aria-hidden="true">↻</div><h3>Bu deneme tamamlanamadı</h3><p data-fto-failed-text>Deneme hakkın kullanılmadı. Başka bir fotoğrafla yeniden deneyebilirsin.</p><button type="button" class="fto__button" data-fto-again>Yeniden dene</button></div>
      <div data-fto-panel="result" hidden><p class="fto__eyebrow" data-fto-result-label>SENİN GÖRÜNÜMÜN</p><img class="fto__result-img" data-fto-result alt="Sanal deneme sonucun"><p class="fto__result-caption">Yapay zekâ ile oluşturuldu. Renk, doku ve kesimde farklılıklar olabilir.<br>Beden ve kalıp bilgisi için ürün açıklamasını incele.</p><div class="fto__result-actions"><a class="fto__button" data-fto-download download="FABLAIR-Sanal-Deneme.png">Görseli indir</a><button type="button" class="fto__button fto__button--light" data-fto-close>Ürüne dön</button><button type="button" class="fto__button fto__button--light fto__again" data-fto-again>Başka bir deneme</button></div></div>
      <p class="fto__status" role="status" aria-live="polite" aria-atomic="true" data-fto-status></p>
    </div>`;

  class FablairTryOn extends HTMLElement {
    connectedCallback() {
      if (this.ready) { document.addEventListener('variant:update', this.variantHandler); return; }
      if (this.closest('quick-add-dialog,quick-add-component,[data-quick-view],.quick-add-modal')) { this.hidden = true; return; }
      this.ready = true;
      this.session = null;
      this.jobId = null;
      this.jobState = null;
      this.posting = false;
      this.polling = false;
      this.stale = false;
      this.photo = null;
      this.photoURL = null;
      this.resultURL = null;
      this.photoVersion = 0;
      this.sessionVersion = 0;
      this.variant = this.dataset.variantId;
      this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`) || this.closest('.shopify-section') || this.parentElement;
      this.launch = this.querySelector('[data-fto-open]');
      this.base = this.dataset.proxyBase || '/apps/fablair-dene';
      if (!/^\/apps\/[A-Za-z0-9][A-Za-z0-9_-]*$/.test(this.base)) {
        this.launch.disabled = true;
        this.launch.title = 'Sanal deneme şu anda kullanılamıyor.';
        return;
      }
      // Keep the existing key: a pending earlier request must be resolved before a new one.
      // It contains only the opaque job and owner IDs, never a photo or an API key.
      this.storageKey = `fablair-tryon:${this.base}:job`;
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'fto__dialog';
      this.dialog.setAttribute('aria-label', 'FABLAIR sanal deneme');
      this.dialog.innerHTML = shell;
      this.append(this.dialog);
      this.dialog.querySelector('h2').id = `fto-title-${this.dataset.sectionId || 'preview'}-${Math.random().toString(36).slice(2, 8)}`;
      this.dialog.setAttribute('aria-labelledby', this.dialog.querySelector('h2').id);
      this.refs = {};
      for (const element of this.dialog.querySelectorAll('*')) for (const attribute of element.attributes) {
        if (attribute.name.startsWith('data-fto-') && attribute.name !== 'data-fto-panel') this.refs[attribute.name.slice(9)] = element;
      }
      this.refs.login.href = this.safeNavigationURL(this.dataset.loginUrl, '/account/login');
      this.refs.privacy.href = this.safeNavigationURL(this.dataset.privacyUrl, '/policies/privacy-policy');
      this.launch.addEventListener('click', () => this.open());
      this.dialog.querySelectorAll('[data-fto-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', () => this.onClose());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } });
      this.refs.pick.addEventListener('click', () => this.refs.file.click());
      this.refs.file.addEventListener('change', () => this.selectFile(this.refs.file.files?.[0]));
      this.refs.remove.addEventListener('click', () => this.clearPhoto());
      this.refs.consent.addEventListener('change', () => this.updateStart());
      this.refs.start.addEventListener('click', () => this.start());
      this.refs.reload.addEventListener('click', () => this.loadSession());
      this.refs.resume.addEventListener('click', () => this.poll(true));
      this.dialog.querySelectorAll('[data-fto-again]').forEach(button => button.addEventListener('click', () => this.again()));
      this.variantHandler = event => this.onVariant(event);
      document.addEventListener('variant:update', this.variantHandler);
      this.restoreJob();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.variantHandler);
      this.sessionVersion++;
      if (this.dialog?.open) this.dialog.close();
      this.revoke('photoURL');
      this.revoke('resultURL');
    }

    safeNavigationURL(value, fallback) {
      try { const url = new URL(value || fallback, location.href); return url.protocol === 'https:' || (url.origin === location.origin && url.protocol === 'http:') ? url.href : fallback; } catch { return fallback; }
    }

    setStatus(text = '', error = false) {
      this.refs.status.textContent = text;
      this.refs.status.toggleAttribute('data-error', error);
    }

    panel(name) {
      this.dialog.querySelectorAll('[data-fto-panel]').forEach(el => { el.hidden = el.dataset.ftoPanel !== name; });
      this.panelName = name;
      this.dialog.setAttribute('aria-busy', name === 'checking' ? 'true' : 'false');
    }

    gate(title, text, login = false, retry = false) {
      this.panel('gate');
      this.refs['gate-title'].textContent = title;
      this.refs['gate-text'].textContent = text;
      this.refs.login.hidden = !login;
      this.refs.reload.hidden = !retry;
    }

    async open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.restoreJob();
      await this.loadSession();
    }

    onClose() {
      document.documentElement.style.overflow = this.oldOverflow || '';
      this.previousFocus?.focus?.({ preventScroll: true });
      // Closing does not cancel a paid request. The opaque ID stays available.
    }

    currentVariant() {
      const form = this.section?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] form`);
      const formId = form?.querySelector('[name="id"]')?.value;
      const urlId = new URLSearchParams(location.search).get('variant');
      return /^\d+$/.test(formId || '') ? formId : /^\d+$/.test(this.variant || '') ? this.variant : /^\d+$/.test(urlId || '') ? urlId : '';
    }

    onVariant(event) {
      const detail = event.detail || {};
      const target = event.target;
      if (target instanceof Element && target.closest('quick-add-dialog,quick-add-component,[data-quick-view],.quick-add-modal')) return;
      if (!(target instanceof Element) || !this.section?.contains(target)) return;
      if (detail.data?.newProduct && String(detail.data.newProduct.id) !== String(this.dataset.productId)) {
        this.stale = true;
        this.session = null;
        this.launch.disabled = true;
        this.refs.start.disabled = true;
        this.sessionVersion++;
        if (this.dialog.open && !this.jobId) this.gate('Ürün değişti', 'Sanal denemeye devam etmek için bu ürünün sayfasını yeniden aç.');
        return;
      }
      if (String(detail.data?.productId || '') !== String(this.dataset.productId)) return;
      this.variant = detail.resource?.id ? String(detail.resource.id) : '';
      this.session = null;
      this.sessionVersion++;
      this.refs.consent.checked = false;
      this.updateStart();
      // A submitted job always keeps its original server-side product snapshot.
      if (this.dialog.open && !this.jobId) queueMicrotask(() => this.loadSession());
    }

    async api(path, body) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), body ? 60000 : 30000);
      try {
        const response = await fetch(this.base + path, {
          method: body ? 'POST' : 'GET', credentials: 'same-origin', redirect: 'error',
          cache: 'no-store', signal: controller.signal,
          headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
          ...(body ? { body: JSON.stringify(body) } : {})
        });
        let data;
        try { data = await response.json(); } catch { throw new Error('Yanıt doğrulanamadı.'); }
        if (!response.ok || data.ok !== true) {
          const error = new Error(typeof data.message === 'string' ? data.message : 'İşlem şu anda tamamlanamıyor.');
          error.code = data.code;
          error.httpStatus = response.status;
          error.data = data;
          throw error;
        }
        return data;
      } finally { clearTimeout(timer); }
    }

    quota(data) {
      const valid = Number.isInteger(data.remaining) && data.remaining >= 0 && data.remaining <= 2 &&
        data.limit === 2 && data.quotaScope === 'pilot' && data.pilotId === PILOT_ID && data.resetsAt === null;
      this.dialog.querySelector('.fto__quota').hidden = !valid;
      if (!valid) return false;
      this.refs.quota.textContent = `Kalan deneme hakkın: ${data.remaining} / 2`;
      this.dialog.querySelectorAll('.fto__dots i').forEach((dot, i) => dot.toggleAttribute('data-on', i < data.remaining));
      this.refs.reset.textContent = 'Üyelere özel · Toplam 2 ücretsiz deneme';
      return true;
    }

    product(data) {
      if (!data || !data.title || !data.variantId || !data.handle) return false;
      try {
        const url = new URL(data.image, location.href);
        const demoData = this.hasAttribute('data-preview') && /^data:image\/(png|jpeg|webp);base64,/.test(data.image);
        if (!demoData && (url.protocol !== 'https:' || !(/(^|\.)shopify\.com$/i.test(url.hostname) || url.origin === location.origin))) return false;
      } catch { return false; }
      this.refs['product-image'].src = data.image;
      this.refs['product-title'].textContent = data.title;
      this.refs['product-variant'].textContent = data.variantTitle === 'Default Title' ? '' : (data.variantTitle || '');
      return true;
    }

    async loadSession() {
      if (this.stale) { this.gate('Ürün değişti', 'Devam etmek için ürün sayfasını yeniden aç.'); return; }
      const version = ++this.sessionVersion;
      this.session = null;
      this.updateStart();
      this.setStatus();
      if (!this.posting && !this.polling) this.panel('checking');
      try {
        const variant = this.currentVariant();
        if (!variant) throw new Error('Lütfen önce bir ürün seçeneği seç.');
        const data = await this.api(`/session?handle=${encodeURIComponent(this.dataset.handle)}&variant=${encodeURIComponent(variant)}`);
        if (version !== this.sessionVersion || !this.isConnected) return;
        if (typeof data.loggedIn !== 'boolean') throw new Error('Üyelik doğrulanamadı. Lütfen yeniden giriş yap.');
        if (!data.loggedIn) {
          this.dialog.querySelector('.fto__quota').hidden = true;
          this.gate('Sana özel 2 ücretsiz deneme', 'Üye girişi yaparak beğendiğin parçaları kendi fotoğrafında ücretsiz deneyebilirsin.', true);
          return;
        }
        if (typeof data.customerScope !== 'string' || !/^[A-Za-z0-9_-]{16,128}$/.test(data.customerScope)) throw new Error('Üyelik doğrulanamadı. Lütfen yeniden giriş yap.');
        if (this.ownerScope && this.ownerScope !== data.customerScope) {
          this.forgetJob(); this.clearPhoto(); this.revoke('resultURL');
          this.refs.result.removeAttribute('src'); this.refs.download.removeAttribute('href');
        }
        this.ownerScope = data.customerScope;
        if (!this.quota(data) || typeof data.enabled !== 'boolean' || typeof data.canGenerate !== 'boolean') throw new Error('Deneme hakların doğrulanamadı. Lütfen yeniden kontrol et.');
        const activeId = UUID.test(data.activeJobId || '') ? data.activeJobId : null;
        if (activeId) { this.rememberJob(activeId); }
        if (this.jobId) { await this.poll(true); return; }
        if (!data.enabled) { this.gate('Kısa bir ara', data.message || 'Sanal deneme şu anda kullanılamıyor. Biraz sonra yeniden kontrol edebilirsin.', false, true); return; }
        if (data.remaining === 0) { this.gate('Deneme haklarını kullandın', 'Ücretsiz 2 deneme hakkını kullandın. Beğendiğin parçaları ürün sayfalarında incelemeye devam edebilirsin.'); return; }
        if (!data.canGenerate) { this.gate('Sanal denemeye kısa bir ara', data.message || 'Sınırlı sayıdaki ücretsiz deneme kapasitemiz doldu. Kalan kişisel hakkın olsa da şu anda yeni bir deneme başlatamıyoruz.', false, true); return; }
        if (!data.csrfToken || !this.product(data.product) || String(data.product.variantId) !== String(variant) || data.product.handle !== this.dataset.handle) throw new Error('Seçtiğin ürün doğrulanamadı. Lütfen ürün sayfasını yenile.');
        this.session = data;
        this.panel('upload');
        this.updateStart();
      } catch (error) {
        if (version !== this.sessionVersion) return;
        this.gate('Şu anda bağlanamıyoruz', error.message === 'Failed to fetch' ? 'Bağlantını kontrol edip yeniden deneyebilirsin.' : error.message, false, true);
      }
    }

    async selectFile(file) {
      if (!file || this.jobId || !this.session?.canGenerate) return;
      const version = ++this.photoVersion;
      this.clearPhoto(false);
      this.setStatus('Fotoğrafın hazırlanıyor…');
      try {
        if (file.size > MAX_FILE) throw new Error('Fotoğraf en fazla 12 MB olabilir. Daha küçük bir fotoğraf seç.');
        const bytes = new Uint8Array(await file.slice(0, 12).arrayBuffer());
        const jpeg = bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255;
        const png = bytes[0] === 137 && bytes[1] === 80 && bytes[2] === 78 && bytes[3] === 71;
        const webp = String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF' && String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP';
        if (!jpeg && !png && !webp) throw new Error('JPG, PNG veya WebP biçiminde bir fotoğraf seç.');
        const localURL = URL.createObjectURL(file);
        let decoded;
        try {
          decoded = await new Promise((resolve, reject) => { const img = new Image(); img.onload = () => resolve(img); img.onerror = () => reject(new Error('Bu fotoğraf açılamadı. Başka bir fotoğraf seç.')); img.src = localURL; });
        } finally { URL.revokeObjectURL(localURL); }
        if (Math.min(decoded.naturalWidth, decoded.naturalHeight) < 256) throw new Error('Daha net bir fotoğraf seç. Her iki kenar en az 256 piksel olmalı.');
        if (decoded.naturalWidth * decoded.naturalHeight > 100000000) throw new Error('Bu fotoğraf çok büyük. Daha küçük bir kopyasını seç.');
        const ratio = Math.min(1, 2048 / Math.max(decoded.naturalWidth, decoded.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(decoded.naturalWidth * ratio);
        canvas.height = Math.round(decoded.naturalHeight * ratio);
        const context = canvas.getContext('2d');
        if (!context) throw new Error('Tarayıcın fotoğrafı hazırlayamadı.');
        context.fillStyle = '#fff'; context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(decoded, 0, 0, canvas.width, canvas.height);
        let data = '';
        // Prefer high fidelity; reduce JPEG quality only if the 6 MiB upload limit requires it.
        for (const quality of [.95, .92, .90, .85]) {
          data = canvas.toDataURL('image/jpeg', quality);
          if (!data.startsWith('data:image/jpeg;base64,')) break;
          if ((data.length - 23) * .75 <= MAX_UPLOAD) break;
        }
        if (!data.startsWith('data:image/jpeg;base64,') || (data.length - 23) * .75 > MAX_UPLOAD) throw new Error('Fotoğraf hazırlanamadı. Daha küçük bir fotoğraf seç.');
        if (version !== this.photoVersion || !this.isConnected) return;
        this.photo = data;
        this.photoURL = URL.createObjectURL(this.imageBlob(data));
        this.refs.person.src = this.photoURL;
        this.refs['person-wrap'].hidden = false;
        this.refs.picker.hidden = true;
        this.setStatus();
      } catch (error) { if (version === this.photoVersion) this.setStatus(error.message, true); }
      this.refs.file.value = '';
      this.updateStart();
    }

    clearPhoto(invalidate = true) {
      if (invalidate) this.photoVersion++;
      this.photo = null;
      this.revoke('photoURL');
      this.refs.person.removeAttribute('src');
      this.refs['person-wrap'].hidden = true;
      this.refs.picker.hidden = false;
      this.refs.consent.checked = false;
      this.refs.file.value = '';
      this.updateStart();
    }

    updateStart() {
      this.refs.start.disabled = !this.photo || !this.refs.consent.checked || !this.session?.canGenerate || !this.session?.csrfToken || !!this.jobId || this.posting || this.stale;
    }

    rememberJob(id) {
      if (!UUID.test(id || '')) throw new Error('Deneme numarası doğrulanamadı.');
      this.jobId = id;
      try { sessionStorage.setItem(this.storageKey, JSON.stringify({ jobId: id, customerScope: this.ownerScope })); } catch { /* memory still prevents duplicate submission */ }
    }

    restoreJob() {
      try { const stored = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); if (UUID.test(stored?.jobId || '') && typeof stored.customerScope === 'string') { this.jobId = stored.jobId; this.ownerScope = stored.customerScope; } } catch { /* storage can be unavailable */ }
    }

    forgetJob() {
      this.jobId = null; this.jobState = null;
      try { sessionStorage.removeItem(this.storageKey); } catch { /* no photos or credentials are stored */ }
    }

    async start() {
      this.updateStart();
      if (this.refs.start.disabled) return;
      // A synchronous lock and persistence precede the only paid POST call.
      this.posting = true;
      const session = this.session;
      if (String(this.currentVariant()) !== String(session.product.variantId)) {
        this.posting = false; this.refs.consent.checked = false; await this.loadSession(); return;
      }
      const id = crypto.randomUUID();
      this.rememberJob(id);
      this.jobState = 'submitting';
      this.updateStart();
      this.showProgress();
      this.setStatus();
      try {
        const data = await this.api('/jobs', { handle: session.product.handle, variantId: String(session.product.variantId), personImage: this.photo, requestId: id, csrfToken: session.csrfToken, consent: true });
        this.posting = false;
        this.applyJob(data);
        if (this.jobState === 'submitting' || this.jobState === 'queued' || this.jobState === 'processing') await this.poll();
      } catch (error) {
        this.posting = false;
        if (error.httpStatus >= 400 && error.httpStatus < 500 && DEFINITE_REJECTIONS.has(error.code)) {
          this.forgetJob();
          if (error.code === 'ACTIVE_JOB' && UUID.test(error.data?.activeJobId || '')) {
            this.rememberJob(error.data.activeJobId); await this.poll(true); return;
          }
          this.refs.consent.checked = false;
          await this.loadSession();
          this.setStatus(error.message, true);
        } else {
          this.uncertain('Bağlantı kesildi; denemen başlamış olabilir. Yeni bir deneme başlatmadan mevcut sonucu kontrol et.');
        }
      } finally { this.posting = false; this.updateStart(); }
    }

    showProgress() {
      this.panel('progress');
      this.refs['progress-image'].hidden = !this.photoURL;
      this.refs['progress-symbol'].hidden = !!this.photoURL;
      if (this.photoURL) this.refs['progress-image'].src = this.photoURL;
      this.refs['progress-text'].textContent = this.jobState === 'submitting' || this.jobState === 'queued' ? 'Denemenin sonucu bekleniyor. Bu pencereyi kapatsan da işlem devam eder.' : 'Fotoğrafın işleniyor. Sonucun hazır olduğunda burada görünecek.';
    }

    uncertain(message) {
      this.jobState = 'uncertain';
      this.panel('uncertain');
      this.refs['job-number'].textContent = this.jobId ? `Deneme numarası: ${this.jobId}` : '';
      this.refs['uncertain-text'].textContent = message || 'İşlemin durumu henüz doğrulanamadı. Yeni deneme başlatmadan mevcut sonucu kontrol et.';
      this.setStatus();
      this.updateStart();
    }

    applyJob(data) {
      if (!UUID.test(data.jobId || '') || data.jobId !== this.jobId || !STATES.has(data.status)) throw new Error('Deneme yanıtı doğrulanamadı.');
      if (!this.quota(data)) throw new Error('Deneme hakların doğrulanamadı.');
      this.jobState = data.status;
      if (data.product) this.product(data.product);
      if (data.status === 'completed' && data.code === 'OUTPUT_UNAVAILABLE' && !data.image) {
        this.panel('failed');
        this.refs['failed-text'].textContent = data.message || 'Bu denemenin görseline erişim süresi doldu. Kullanılmış deneme hakkı geri yüklenmez.';
        this.dialog.querySelector('[data-fto-panel="failed"] h3').textContent = 'Görselin süresi doldu';
      } else if (data.status === 'completed') {
        let blob;
        try { blob = this.imageBlob(data.image); } catch {
          this.panel('failed');
          this.dialog.querySelector('[data-fto-panel="failed"] h3').textContent = 'Sonuç görüntülenemedi';
          this.refs['failed-text'].textContent = 'Denemen tamamlandı ancak görsel doğrulanamadı. Bu işlem için deneme hakkın kullanılmış olabilir. Yeni bir denemeden önce kalan haklarını kontrol edebilirsin.';
          return;
        }
        this.revoke('resultURL');
        this.resultURL = URL.createObjectURL(blob);
        this.refs.result.src = this.resultURL;
        this.refs.download.href = this.resultURL;
        this.refs.download.download = `FABLAIR-Sanal-Deneme.${blob.type === 'image/jpeg' ? 'jpg' : blob.type === 'image/webp' ? 'webp' : 'png'}`;
        this.panel('result');
        this.setStatus();
      } else if (data.status === 'failed') {
        this.panel('failed');
        this.dialog.querySelector('[data-fto-panel="failed"] h3').textContent = 'Bu deneme tamamlanamadı';
        this.refs['failed-text'].textContent = data.message || 'Deneme hakkın kullanılmadı. Başka bir fotoğrafla yeniden deneyebilirsin.';
      } else if (data.status === 'uncertain') {
        this.uncertain(data.message);
      } else this.showProgress();
      this.updateStart();
    }

    async poll(manual = false) {
      if (!this.jobId || this.polling || this.posting) return;
      this.polling = true;
      this.refs.resume.disabled = true;
      const id = this.jobId;
      const deadline = Date.now() + 240000;
      if (manual) { this.showProgress(); this.setStatus('Mevcut denemen kontrol ediliyor…'); }
      try {
        do {
          let data;
          try { data = await this.api(`/jobs/${encodeURIComponent(id)}`); } catch (error) {
            if (error.httpStatus === 429 && error.code === 'RATE_LIMITED') {
              await new Promise(resolve => setTimeout(resolve, Math.max(3, Math.min(Number(error.data?.retryAfterSeconds) || 3, 10)) * 1000));
              continue;
            }
            throw error;
          }
          if (this.jobId !== id || !this.isConnected) return;
          this.applyJob(data);
          if (['completed', 'failed', 'uncertain'].includes(this.jobState)) return;
          if (!this.dialog.open) return;
          await new Promise(resolve => setTimeout(resolve, 3000));
        } while (Date.now() < deadline);
        this.uncertain('Denemen beklenenden uzun sürüyor. Biraz sonra mevcut sonucu yeniden kontrol edebilirsin.');
      } catch (error) {
        if (this.jobId === id) this.uncertain(error.httpStatus === 404 ? 'Deneme kaydı henüz doğrulanamadı. İşlem devam ediyor olabilir; yeni bir deneme başlatmadan tekrar kontrol et. Durum değişmezse mağazayla iletişime geç.' : 'Sonucu şu anda kontrol edemedik. Mevcut denemen korunuyor; biraz sonra yeniden kontrol edebilirsin.');
      } finally { this.polling = false; this.refs.resume.disabled = false; }
    }

    imageBlob(data) {
      if (typeof data !== 'string' || data.length > 4 * Math.ceil(MAX_OUTPUT / 3) + 32) throw new Error('Sonuç görseli doğrulanamadı.');
      const match = /^data:(image\/(?:png|jpeg|webp));base64,([A-Za-z0-9+/]+={0,2})$/.exec(data);
      if (!match || match[2].length % 4 !== 0) throw new Error('Sonuç görseli doğrulanamadı.');
      const decodedLength = match[2].length / 4 * 3 - (match[2].endsWith('==') ? 2 : match[2].endsWith('=') ? 1 : 0);
      if (decodedLength > MAX_OUTPUT) throw new Error('Sonuç görseli çok büyük.');
      const raw = atob(match[2]);
      const bytes = Uint8Array.from(raw, char => char.charCodeAt(0));
      const magicOK = match[1] === 'image/png' ? bytes[0] === 137 && bytes[1] === 80 && bytes[2] === 78 && bytes[3] === 71 : match[1] === 'image/jpeg' ? bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255 : String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF' && String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP';
      if (!magicOK) throw new Error('Sonuç görseli doğrulanamadı.');
      return new Blob([bytes], { type: match[1] });
    }

    revoke(property) { if (this[property]) { URL.revokeObjectURL(this[property]); this[property] = null; } }

    async again() {
      if (!['completed', 'failed'].includes(this.jobState) || this.posting || this.polling) return;
      this.forgetJob();
      this.clearPhoto();
      this.revoke('resultURL');
      this.refs.result.removeAttribute('src');
      this.refs.download.removeAttribute('href');
      this.refs.consent.checked = false;
      await this.loadSession();
    }
  }
  customElements.define('fablair-try-on', FablairTryOn);
})();

